<template>
  <el-form
    ref="baseForm"
    :model="baseForm"
    :inline="isInline"
    :label-position="labelP"
    :label-width="labelW"
    class="base-form"
    :class="{'not-padding': notP}"
  >
    <template v-for="(item, index) in formData">
      <template v-if="insertSlotArr.indexOf(index) !== -1">
        <slot :name="`OI${index}`" />
      </template>
      <el-form-item
        v-if="item.type === 'select'"
        :key="index"
        :label="item.labelH ? '' : item.label1 || item.label"
        :prop="item.key"
        :class="item.class || 'c-1'"
        :label-width="item.labelH ? 'auto' : item.labelW || labelW"
        :rules="item.rules ? item.rules instanceof Object && item.rules.length > 0 ? item.rules : [{ required: true, message: `请选择${item.label1 || item.label}`, trigger: 'blur' }] : {}"
      >
        <el-select
          v-model.trim="baseForm[item.key]"
          clearable
          :placeholder="`请选择${item.label1 || item.label}`"
          :disabled="item.disabled || false"
          :multiple="item.multiple || false"
          :filterable="item.filterable || true"
          @change="changeHandle"
        >
          <el-option
            v-for="(o, i) in item.options"
            :key="i"
            :label="o.key"
            :value="o.val"
            :disabled="o.disabled"
          >{{ o.key }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-else
        :key="index"
        :label="item.labelH ? '' : item.label1 || item.label"
        :prop="item.key"
        :class="item.class || 'c-1'"
        :label-width="item.labelH ? 'auto' : item.labelW || labelW"
        :rules="item.rules ? item.rules instanceof Object && item.rules.length > 0 ? item.rules : [{ required: true, message: `请输入${item.label1 || item.label}`, trigger: 'blur' }] : {}"
      >
        <el-input
          v-model.trim="baseForm[item.key]"
          :type="item.type || 'text'"
          :size="item.size || 'medium'"
          :show-password="item.showp || false"
          :placeholder="`请输入${item.label1 || item.label}`"
          :disabled="item.disabled || false"
          :clearable="item.clear || true"
          :maxlength="item.maxlength || false"
          :prefix-icon="item.pIcon || ''"
          @input="changeHandle"
        />
      </el-form-item>
    </template>
    <slot name="otherItem" />
    <el-form-item>
      <slot name="footer" />
    </el-form-item>
  </el-form>
</template>
<script>
// import { strTrim } from '@/utils'
export default {
  name: 'BaseForm',
  props: {
    formData: {
      default: () => [],
      type: Array
    },
    isInline: { // 行内展示
      default: false,
      type: Boolean
    },
    labelP: {
      default: 'right',
      type: String
    },
    labelW: {
      default: '80px',
      type: String
    },
    notP: {
      default: true,
      type: Boolean
    },
    insertSlotArr: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      baseForm: {}
    }
  },
  watch: {},
  methods: {
    changeHandle (val) {
      // console.log(val)
      this.$nextTick(() => {
        // if (curFormItem) {
        //   if (curFormItem.changeHandle) {
        //     if (curFormItem.type === 'selectRemote' && curFormItem.remoteOptions) {
        //       let curOption = {}
        //       curFormItem.remoteOptions.forEach(item => {
        //         if (item.valRO === val) {
        //           curOption = item
        //         }
        //       })
        //       curFormItem.changeHandle(val, curFormItem, curOption)
        //     } else {
        //       curFormItem.changeHandle(val, curFormItem, this.curFormIndex)
        //     }
        //   }
        // }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.base-form {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  &.not-padding {
    padding: 0;
  }
  /deep/ .el-form-item {
    display: flex;
    align-items: center;
    &.c-1 {
      flex: 0 0 100%;
    }
    &.c-2 {
      flex: 0 0 50%;
      margin-right: 10px;
    }
    &.c-3 {
      width: 33.33%;
    }
    .el-form-item__label {
      font-size: 14px;
      line-height: 14px;
    }
    .el-form-item__content {
      flex: 1;
      margin-left: 0px !important;
      .el-input__inner {
        height: 42px;
        line-height: 42px;
        font-size: 14px;
      }
      .el-input__icon {
        font-size: 14px;
      }
      .el-select {
        width: 100%;
      }
    }
  }
}
.el-form--label-top {
  /deep/ .el-form-item {
    display: block !important;
    .el-form-item__label {
      font-size: 16px;
      line-height: 16px;
      padding-bottom: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseForm/index.vue